import { PushPlatformHint } from '@gb-ticket/shared-types';
import { SmartphoneIcon } from 'lucide-react';

import { detectPlatformHint } from './push-support';

export const PUSH_ASK_PERMISSION_BUTTON_LABEL = 'Browser nach Erlaubnis fragen';

export function PushIosInstallHint() {
  if (detectPlatformHint() !== PushPlatformHint.MOBILE_IOS) {
    return null;
  }

  return (
    <p className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100">
      <SmartphoneIcon className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>
        Für Push auf dem iPhone: App zum Home-Bildschirm hinzufügen (Teilen → Zum Home-Bildschirm),
        dann hier „{PUSH_ASK_PERMISSION_BUTTON_LABEL}“ wählen.
      </span>
    </p>
  );
}
